import { api } from './client';

export const levelUpgradeAPI = {
  rpToApPreview: () =>
    api.get<{
      rp_balance: string;
      ap_balance: string;
      ratio: string;
      hint: string;
    }>('/api/level-upgrade/rp-to-ap/preview'),

  rpToApExecute: (body: {
    amount: string;
    transaction_password: string;
    security_answer: string;
    memo?: string;
    idempotency_key?: string;
  }) => api.post<Record<string, unknown>>('/api/level-upgrade/rp-to-ap', body),

  rpApOrbPreview: (target_level: string) =>
    api.get<Record<string, unknown>>('/api/level-upgrade/rp-ap-orb/preview', {
      target_level,
    }),

  rpApOrbExecute: (body: {
    target_level: string;
    transaction_password: string;
    security_answer: string;
    memo?: string;
    idempotency_key?: string;
  }) => api.post<Record<string, unknown>>('/api/level-upgrade/rp-ap-orb/execute', body),
};
